<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{item.cu_sellername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户编号</label>
            <span class="weui-form-preview__value">{{item.cu_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{item.cu_name}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">{{ "报价" }}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">商品个数</label>
            <span class="weui-form-preview__value">{{item.ir_count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">转化订单个数</label>
            <span class="weui-form-preview__value">{{item.sa_count}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">转化率%</label>
            <span class="weui-form-preview__value">{{item.rate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data() {
    return {

    }
  }
};
</script>